import {
  CreateCompositionMaterialRequest,
  compositionApi,
} from '@texas/api/endpoints/compositionApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { SharedDisclosureProps } from '@texas/components/shared/types';
import {
  CompositionMaterialForm,
  MaterialFormType,
} from './CompositionMaterialForm';
import { useEffect } from 'react';
import { ErrorDetails } from '@texas/components/shared/alert/ErrorDetails';
import { CompositionTreatmentsForm } from './CompositionTreatmentsForm';

interface UpdateCompositionMaterialProps extends SharedDisclosureProps {
  compositionMaterialId: number;
  productGroupId: number | null;
  onSubmit: (data: CreateCompositionMaterialRequest) => void;
  formType?: MaterialFormType;
  isReady: boolean;
  groupHasAnyBasedOn: boolean;
  vdcTemplate: boolean;
}

export function UpdateCompositionMaterial({
  compositionMaterialId,
  productGroupId,
  isOpen,
  onClose,
  onSubmit,
  formType,
  isReady,
  groupHasAnyBasedOn,
  vdcTemplate,
}: UpdateCompositionMaterialProps) {
  const {
    data,
    refetch,
    loading,
    error: getError,
  } = useApiResource(compositionApi.getCompositionMaterial);

  useEffect(() => {
    if (!isOpen) return;
    refetch(compositionMaterialId);
  }, [compositionMaterialId, refetch, isOpen]);

  if (getError) {
    return <ErrorDetails error={getError} />;
  }

  if (formType === 'vdc') {
    return (
      <CompositionTreatmentsForm
        loading={loading}
        compositionMaterial={data}
        onClose={onClose}
        isOpen={isOpen}
      />
    );
  }
  return (
    <CompositionMaterialForm
      formType={formType}
      loading={loading}
      compositionMaterial={data}
      onClose={onClose}
      isOpen={isOpen}
      productGroupId={productGroupId}
      onFormSubmit={(data) => onSubmit(data)}
      isReady={isReady}
      groupHasAnyBasedOn={groupHasAnyBasedOn}
      vdcTemplate={vdcTemplate}
    />
  );
}
